import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~100vh
      setIsVisible(window.scrollY > window.innerHeight);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] bg-background/95 backdrop-blur border-t border-border md:hidden animate-fade-in">
      <a href="/servicios/diagnostico-ia" className="block">
        <Button 
          className="w-full h-12 text-base font-semibold"
          size="lg"
        >
          Diagnóstico gratis →
        </Button>
      </a>
    </div>
  );
};

export default StickyMobileCTA;
